import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import classNames from 'classnames'

import WorkflowTools from '../components/WorkflowTools'

export default class WorkflowToolsContainer extends Component {

  static propTypes = {
    children: PropTypes.node,
    context: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
  }

  @autobind
  handleChange(e) {
    const { target } = e
    if (this.props.onChange && target.name.startsWith('_message')) {
      this.props.onChange({
        target: {
          name: target.name,
          value: target.value !== undefined
            ? {
              name: this.props.name,
              label: this.props.label,
              value: target.value
            }
            : null
        }
      })
    }
  }

  render() {
    const {
      children,
      context,
      ...workflowToolsProps
    } = this.props

    if (!context.getRejectionMessage) {
      return null
    }

    const message = context.getRejectionMessage(workflowToolsProps.name)

    return (
      <div
        className={classNames('form-group-container', {
          'with-reject-form': message !== undefined
        })}
        onChange={this.handleChange}
      >

        {children}

        <WorkflowTools
          {...workflowToolsProps}
          key={`workflow-tools-${workflowToolsProps.name}`}
          message={message}
          onChange={this.handleChange}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/WorkflowTools.js